// src/utils/sanitizeHtml.ts
import DOMPurify from 'dompurify';

type Allowed = {
  ALLOWED_TAGS?: string[];
  ALLOWED_ATTR?: string[];
};

export function sanitizeHtml(html: string, opts?: Allowed) {
  const base: Allowed = {
    ALLOWED_TAGS: ['p', 'ul', 'li', 'strong', 'b', 'u', 'br', 'span'],
    ALLOWED_ATTR: [],
  };
  const config: any = { ...(base as any), ...(opts || {}) };

  // Si Trusted Types sont dispo, demande un TrustedHTML
  if (typeof window !== 'undefined' && (window as any).trustedTypes) {
    (config as any).RETURN_TRUSTED_TYPE = true;
  }

  return DOMPurify.sanitize(html, config);
}
